import moment from 'moment';
import 'moment/locale/zh-cn'

import PageContainer from './container/PageContainer';
import PageContainer2 from './container/PageContainer2';
import PaginationTable from './table/PaginationTable';
import DateTimeRender from './render/DateTimeRender';
import DateRender from './render/DateRender';
import FormContainer from "./container/FormContainer";
import ExcelEditor from './editor/ExcelEditor';
import querystring from 'querystring';
import Bridge from '@/router/bridge';
import QiniuElUpload from './editor/QiniuElUpload';
import FileUpload from './editor/FileUpload';
import PermissionContainer from './container/PermissionContainer';
import HeaderContainer from './container/HeaderContainer';
import SearchForm from './form/SearchForm';
import ImagePreview from './dialog/ImagePreview';
import StateDisplay from "./render/StateDisplay";
import DialogTable from './table/DialogTable';
import CardTable from "./table/CardTable";
import DataCardTable from "./table/DataCardTable";
import MoneyRender from './render/MoneyRender';
import LinkContainer from "./container/LinkContainer";
import DividerLine from './render/DividerLine';
import CustomImage from "./others/CustomImage";
import DialogDirective from './dialog/directives';
import EnumRender from "./render/EnumRender";

const components =
[
    PageContainer,
    PageContainer2,
    PaginationTable,
    DateTimeRender,
    DateRender,
    FormContainer,
    ExcelEditor,
    QiniuElUpload,
    FileUpload,
    PermissionContainer,
    HeaderContainer,
    SearchForm,
    ImagePreview,
    StateDisplay,
    DialogTable,
    CardTable,
    DataCardTable,
    MoneyRender,
    LinkContainer,
    DividerLine,
    CustomImage,
    EnumRender
];
const SevenDay = 7*24*3600*1000;
const timeDuration = function (duration)
{
    let d = Math.floor(duration/(24*3600*1000));
    duration = duration%(24*3600*1000);
    let h = Math.floor(duration/(3600*1000));
    duration = duration%(3600*1000);
    let m = Math.floor(duration/60000);
    duration = duration%60000;
    let s = Math.floor(duration/1000);
    let caption = `${d?d+'天':''}${h?h+'小时':''}${m?m+'分钟':''}`;
    return caption? caption : `${s}秒`
};
const install = function (Vue, opts={})
{
    components.forEach((component)=>
    {
        Vue.component(component.name, component);
    });
    Vue.prototype.showMessageSuccess = function (message, onClose, duration)
    {
        return this.$message&&this.$message({
            message: message||'Success',
            type: 'success',
            showClose: true,
            duration: 1000,
            onClose: onClose||(()=>{})
        });
    };
    Vue.prototype.showMessageError = function(errorMessage)
    {
        return this.$message&&this.$message.error(errorMessage||"未知错误");
    };

    Vue.prototype.showMessageWarning = function(message, onClose)
    {
        return this.$message&&this.$message({
            message,
            type: 'warning',
            onClose: onClose||(()=>null),
        });
    };

    Vue.prototype.showConfirm = function (message, options={
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        title: '提示',
    }) {
        return this.$confirm(message, options.title, options).then(() => true).catch(err =>
        {
            if (err == 'cancel') // element 点取消会抛出这个
                return false;
            throw err;
        });
    };
    Vue.prototype.dispatchRouteBack = function ()
    {
        this.$store.dispatch('layout/routeBack');
    };
    Vue.prototype.dispatchRouteTo = function (path, params)
    {
        let fullPath = path;
        let query = querystring.stringify(params);
        if(query)
        {
            fullPath = `${fullPath}?${query}`;
        }
        let bridge = new Bridge();
        this.$store.dispatch('layout/routeTo', {path: fullPath, bridge: bridge});
        this.$router.push(fullPath);
        return bridge;
    };
    Vue.prototype.dispatchOpenTab = function (path, params, options)
    {
        let fullPath = path;
        let query = querystring.stringify(params);
        if(query)
        {
            fullPath = `${fullPath}?${query}`;
        }
        let bridge = new Bridge();
        this.$store.dispatch('layout/openTab', {path: fullPath, bridge: bridge, ...options});
        this.$router.push(fullPath);
        return bridge;
    };
    Vue.prototype.dispatchFocusTab = function (path, params)
    {
        let bridge = new Bridge();
        this.$store.dispatch('layout/focusTab', {path: path, bridge: bridge, ...params});
        this.$router.push(path);
        return bridge;
    };
    Vue.prototype.getRouteBridge = function ()
    {
        return this.$store.getters['layout/getCurrentBridge']||new Bridge();
    };
    moment.locale('zh-cn');
    Vue.prototype.moment = moment;
    Vue.prototype.formatDate = function (timestamp, separator='-')
    {
        if(!timestamp) return '-';
        return moment(timestamp).format(`YYYY${separator}MM${separator}DD`);
    };
    Vue.prototype.formatDateTime = function (timestamp, separator='-')
    {
        if(!timestamp) return '-';
        return moment(timestamp).format(`YYYY${separator}MM${separator}DD HH:mm:ss`);
    };
    Vue.prototype.momentTimeFormat = function(timestamp, format='YYYY-MM-DD HH:mm:ss') {
        if (!timestamp)
            return '-';
        return moment(timestamp).format(format);
    };
    Vue.prototype.momentHumanize = function(timestamp, showDurationDetail)
    {
        if(!timestamp) return '-';
        let now = new Date();
        if(now.getTime() == timestamp) return '当前';
        if(now.getTime() > timestamp)
        {
            if((now.getTime() - SevenDay) < timestamp)
            {
                let duration = now.getTime()-timestamp;
                if(!showDurationDetail && duration > 3600000)
                {
                    return moment().from(timestamp, true)+'前';
                }
                else
                {
                    return timeDuration(duration)+'前';
                }
            }
        }
        else
        {
            if((now.getTime() + SevenDay) > timestamp)
            {
                let duration = timestamp - now.getTime();
                if(!showDurationDetail && duration > 3600000)
                {
                    return moment().to(timestamp, true)+'后';
                }
                else
                {
                    return timeDuration(duration)+'后';
                }
            }
        }
        if(now.getUTCFullYear() !== new Date(timestamp).getUTCFullYear())
        {
            return moment(timestamp).format('YYYY-MM-DD');
        }
        return moment(timestamp).format('MM-DD');
    };
    Vue.prototype.hasPermission = function (permissionId) {
        return permissionId&&this.$store.state.session.userPermissionIdList.indexOf(permissionId)>=0;
    }
};
export default {
    install
}



// WEBPACK FOOTER //
// ./src/components/index.js